import React from 'react';
import PropTypes from 'prop-types';

export default function withContent(Component) {
  Component.contextTypes = Component.contextTypes || {};
  Component.contextTypes.content = PropTypes.object.isRequired;
  return Component;
}



// WEBPACK FOOTER //
// ./spa/Components/Context/withContent.jsx